import { useState } from "react";
import { Tabs, TabList, HStack, TabPanel, Box } from "@chakra-ui/react";
import {
  ActionBar,
  AddFiatAccount,
  AddMobileMoney,
  InputLabel,
  Layout,
  ListBanks,
  PageMotion,
  Select,
  Tab,
  TabPanels,
} from "components";
import { useNavigate } from "react-router";

const FiatAccount = () => {
  const [tabIndex, changeTab] = useState(0);
  const handleTabChange = (index: number) => {
    changeTab(index);
  };

  const navigate = useNavigate();

  const [fiatType, setFiatType] = useState("ngn");

  return (
    <PageMotion px={{ base: "8px", "1sm": "4px" }}>
      <Layout>
        <ActionBar onBackClick={() => navigate(-1)} title="Fiat Account" />

        <Tabs variant="ghost" index={tabIndex} onChange={handleTabChange}>
          <HStack w="100%">
            <TabList w="100%" flex={{ base: "6", "2sm": "4" }} borderRadius="8px">
              <Tab noShadow fontSize="md">
                Add Account
              </Tab>
              <Tab noShadow fontSize="md">
                All Accounts
              </Tab>
            </TabList>
          </HStack>

          <TabPanels index={tabIndex} onChangeIndex={handleTabChange} mt="24px">
            <TabPanel padding={{ base: "1rem 8px", "2sm": "1rem" }}>
              <Box width="100%">
                <InputLabel htmlFor="fiatType">Country</InputLabel>
                <Select id="fiatType" name="country" onChange={(e) => setFiatType(e.target.value)}>
                  <option value="ngn">Nigeria</option>
                  <option value="kes">Kenya</option>
                  <option value="ghs">Ghana</option>
                </Select>
              </Box>

              {fiatType === "ngn" ? (
                <AddFiatAccount changeTab={changeTab} fiatType="ngn" hideCountry />
              ) : (
                <AddMobileMoney changeTab={changeTab} fiatType={fiatType} hideCountry />
              )}
            </TabPanel>

            <TabPanel padding={{ base: "1rem 8px", "2sm": "1rem" }}>
              <ListBanks />
            </TabPanel>
          </TabPanels>
        </Tabs>
      </Layout>
    </PageMotion>
  );
};

export default FiatAccount;
